import React from "react";
import { Button } from "@revvsales/components";

export default function DynamicFieldFooter(props) {
  return (
    <div
      className="clause-options-btns"
      data-test="dynamicfieldfooter-save-discard-btns">
      <Button
        className="btn-transparent"
        data-test="dynamicfieldfooter-cancel-button"
        id="dynamic-field-footer-cancel-btn"
        onClick={props.onDiscard}>
        Discard
      </Button>
      <Button
        id="dynamic-field-footer-save-btn"
        data-test="dynamicfieldfooter-save-button"
        onClick={props.onSave}
        disabled={props.disabled}>
        Save field
      </Button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldFooter/DynamicFieldFooter.js